import { useState } from 'react';
import { IconLink } from '@tabler/icons-react';
import type { Citation } from '../services/types';
import { getFaviconUrl, getSourceHostLabel } from '../utils/citationSource';

const FAVICON_SIZE_PX = 12;
const POPOVER_TEXT = '#ffffff';
const POPOVER_TEXT_MUTED = 'rgba(255,255,255,0.76)';

interface SourceRowProps {
  citation: Citation;
}

export const SourceRow = ({ citation }: SourceRowProps) => {
  const [faviconFailed, setFaviconFailed] = useState(false);
  const url = citation.url ?? '';
  const host = getSourceHostLabel(url);
  const faviconUrl = getFaviconUrl(url);

  return (
    <a
      href={citation.url ?? undefined}
      target="_blank"
      rel="noopener noreferrer"
      className="caddietw-flex caddietw-flex-col caddietw-gap-1 caddietw-no-underline caddietw-cursor-pointer caddietw-py-2 caddietw-px-[9px] caddietw-transition-colors hover:caddietw-bg-white/10"
    >
      <span className="caddietw-flex caddietw-items-center caddietw-gap-1.5">
        {faviconFailed || !faviconUrl ? (
          <IconLink
            size={FAVICON_SIZE_PX}
            stroke={2}
            color={POPOVER_TEXT_MUTED}
          />
        ) : (
          <img
            src={faviconUrl}
            alt=""
            width={FAVICON_SIZE_PX}
            height={FAVICON_SIZE_PX}
            onError={() => setFaviconFailed(true)}
            style={{ display: 'block' }}
          />
        )}
        <span
          className="caddietw-text-[10px] caddietw-leading-[12px]"
          style={{ color: POPOVER_TEXT_MUTED }}
        >
          {host}
        </span>
      </span>
      <span
        className="caddietw-text-xs caddietw-font-medium caddietw-truncate"
        style={{ color: POPOVER_TEXT, lineHeight: '16px' }}
        title={citation.title}
      >
        {citation.title}
      </span>
    </a>
  );
};
